import {observable, action} from 'mobx';
import {api} from 'shared/core';
import {endpoints} from 'main/tools';

class PayrollNotEnabledState {
  @observable interestedInPayrollModalOpen = false;

  @action openInterestedInPayrollModal() {
    this.interestedInPayrollModalOpen = true;
  }

  @action closeInterestedInPayrollModal() {
    this.interestedInPayrollModalOpen = false;
  }

  @action async submit() {
    await api.post(endpoints.PAYROLL.INTERESTED, {source: 'payroll_page'});
    this.openInterestedInPayrollModal();
  }
}

export default PayrollNotEnabledState;
